import { render, staticRenderFns } from "./starting-point-affiliate.vue?vue&type=template&id=4b887eb8&scoped=true&"
import script from "./starting-point-affiliate.vue?vue&type=script&lang=ts&"
export * from "./starting-point-affiliate.vue?vue&type=script&lang=ts&"
import style0 from "./starting-point-affiliate.vue?vue&type=style&index=0&id=4b887eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b887eb8",
  null
  
)

export default component.exports